export default __webpack_public_path__ + "static/2165-2ec61684d11f2fdac8422eba2d9b09e1.gif";